import { COMPANY } from "@/lib/siteData";
import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
    const msg = encodeURIComponent(
        "Hi CHANDAK BuildVision, I'd like to know more about your visualization services."
    );
    const href = `https://wa.me/${COMPANY.phoneIntl.replace(/^\+/, "")}?text=${msg}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full grid place-items-center text-white shadow-lg animate-floaty"
            style={{ background: "#25D366" }}
        >
            <MessageCircle className="h-6 w-6" fill="white" />
            <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
        </a>
    );
}
